import { GridFilterModel } from "@mui/x-data-grid-pro";
import {
  buildCombinedFilter as buildCombinedFilterBase,
  buildOrderBy,
  buildGridifyFilter,
} from "shared/utils/gridify";

const LIBRARY_SEARCH_FIELDS = ["name", "description", "modifiedBy"];

export const buildCombinedFilter = (
  searchText: string,
  gridFilters: GridFilterModel,
): string => {
  return buildCombinedFilterBase(
    searchText,
    gridFilters,
    LIBRARY_SEARCH_FIELDS,
  );
};

export { buildOrderBy, buildGridifyFilter };
